import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class APIInterceptor implements HttpInterceptor {
  
  private baseUrl = environment.baseUrl;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('api')) {
      const apiReq = req.clone({ url: `${this.baseUrl}/${req.url}` });
      return next.handle(apiReq);
    } else {
      return next.handle(req);
    }
  }
}
